import AdminQuoteService from '@/service/AdminQuoteService';
import UploadImageService from '@/service/UploadImageService';
import { defineStore } from 'pinia';

export const useAdminQuoteStore = defineStore('adminQuoteStore', {
  state: () => {
    return {
      statistic: {},
      total: 0,
      currentQuote: {},
      noteList: [],
      reportStatistic: {}
    };
  },
  getters: {
    getUrlUploadImg: () => {
      const service = new UploadImageService();
      return service.urlImage;
    }
  },
  actions: {
    async getStatistic() {
      const service = new AdminQuoteService();
      const res = await service.getStatistic();
      this.statistic = res?.data;
    },
    async getReportStatistic() {
      const service = new AdminQuoteService();
      const res = await service.getReportStatistic();
      this.reportStatistic = res?.data;
    },
    async getListQuotes(role, payload) {
      const service = new AdminQuoteService();
      const res = await service.getListQuotes(role, payload);
      return res?.data;
    },
    async getQuoteDetail(id) {
      const service = new AdminQuoteService();
      const res = await service.getQuoteDetail(id);
      if (res) {
        this.currentQuote = res?.data;
        return res?.data;
      }
    },
    async updateQuote(payload, sk) {
      const service = new AdminQuoteService();
      const res = await service.updateQuote(payload, sk);
      return res?.data;
    },
    async getAirlines() {
      const service = new AdminQuoteService();
      const res = await service.getAirlines();
      return res?.data;
    },
    async getListReportQuotes(payload) {
      const service = new AdminQuoteService();
      const res = await service.getListReportQuotes(payload);
      return res?.data;
    },
    async updateQuoteStatus(sk, sts) {
      const service = new AdminQuoteService();
      const res = await service.updateQuoteStatus(sk, sts);
      return res?.data;
    },
    async updateLangQuote(sk, lang) {
      const service = new AdminQuoteService();
      const res = await service.updateLangQuote(sk, lang);
      return res?.data;
    },
    async updateInternalStatus(sk, sts) {
      const service = new AdminQuoteService();
      const res = await service.updateInternalStatus(sk, sts);
      return res?.data;
    },
    updateAir(airIndex, newFlights, newPrice) {
      this.currentQuote.airs[airIndex].flights = newFlights;
      this.currentQuote.airs[airIndex].price = newPrice;
      return this.currentQuote;
    },
    async getNote(quoteId) {
      const service = new AdminQuoteService();
      const res = await service.getNote(quoteId);
      this.noteList = res?.data;
    },
    async addNote(quoteId, payload) {
      const service = new AdminQuoteService();
      const res = await service.addNote(quoteId, payload);
      return res?.data;
    },

    async updateAcknowledgeNote(quoteId: string, payload: any) {
      const service = new AdminQuoteService();
      const res = await service.updateAcknowledgeNote(quoteId, payload);
      return res?.status;
    },

    async filterNote(quoteId: string, noteType: string, params: any) {
      const service = new AdminQuoteService();
      const res = await service.filterNote(quoteId, noteType, params);
      return res?.data;
    },

    async preSigned(imgUrl: string) {
      const service = new AdminQuoteService();
      const res = await service.preSigned(imgUrl);
      return res?.data;
    },

    async getListVoucher(payload) {
      const service = new AdminQuoteService();
      const res = await service.getListVoucher(payload);
      return res?.data;
    },
    async getContractHotel(hCode) {
      const service = new AdminQuoteService();
      const res = await service.getContractHotel(hCode);
      return res?.data;
    },
    async lastVisitStatic() {
      const service = new AdminQuoteService();
      const res = await service.lastVisitStatic();
      return res?.data;
    }
  }
});
